import { render, staticRenderFns } from "./Spents.vue?vue&type=template&id=33b3e13f&"
import script from "./Spents.vue?vue&type=script&lang=js&"
export * from "./Spents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports